export default function syntaxHighlight (text) {
  const strings = /"(.*?)"/g;
  const keywords = /\b(var|new|const|require|require_once|include|package|import|then|curl|for|if|while|from|in|each|end|print_r|puts|using|use|func|\$)(?=[^\w])/g;
  const namespaces = /\b(registrar|domains|zones|certificates|identity|contacts|\$)(?=[.-])/gi;

  text = text.replace(strings, '<span class=\'hi-string\'>"$1"</span>');
  text = text.replace(keywords, '<span class=\'hi-keyword\'>$1</span>');
  text = text.replace(namespaces, '<span class=\'hi-namespace\'>$1</span>');

  return text;
};
